export default __webpack_public_path__ + "static/media/carousel-next-btn.bc1e561e.svg";